import { Node } from 'slate';

export const getSlateNodeAsTextString = (content, enableTrim = false) => {
  let text = '';
  const node = typeof content === 'string' ? JSON.parse(content) : content;
  if (node) {
    try {
      text += `${node
        .map((n) => {
          const cloneNode = JSON.parse(JSON.stringify(n));
          if (cloneNode.children && n.type === 'p') {
            cloneNode.children = n.children.filter((textNode) => Boolean(textNode.text));
          }
          return Node.string(n);
        })
        .join(' ')}`;
    } catch (ex) {
      console.log('Error getting slate node as text string', ex);
    }
  }
  return enableTrim ? text.trim() : text;
};
